<section class="standart_card"
  [class.horisontal]="award.standart_card.preview?.is_horisontal">
  <div class="standart_card__card">
    <span *ngIf="award.count_cards > 1" class="standart_card__card__count">
      {{ award.count_cards }}
    </span>
    <span>
      <img src="{{ award.standart_card.preview?.url }}" alt="{{ award.standart_card.title }}">
    </span>
  </div>
  <div class="standart_card__info">
    <span class="standart_card__title">
      {{ award.standart_card.title }}
      <span *ngIf="award.standart_card.character?.icon_url" class="standart_card__character">
        <img src="{{ award.standart_card.character.icon_url }}" alt="{{ award.standart_card.character.title }}">
      </span>
    </span>
    <span *ngIf="award.for_what" class="standart_card__for_what">
      {{ award.for_what | wordSlice:4 }}
    </span>
    <span class="standart_card__date">
      {{ award.date | date }}
    </span>
  </div>
</section>
